export function isLocalhost(input: string) {
  return input.match(/^localhost(:\d+)?\/?$/)
}
